import { useSkipFeaturesStore } from '../contractInfo';
import { useAppInfoStore } from './useAppInfoStore';
import { useCheckPasswordStore } from './useCheckPassword';
import { useLoadingStore } from './useLoadingStore';
import { useModalStore } from './useModalStore';
import { useNavigateStore } from './useNavigateStore';
import { useShouldCheckModalStore } from './useShouldCheckModalStore';
import { useToastStore } from './useToastStore';

export {
  useModalStore,
  useToastStore,
  useShouldCheckModalStore,
  useSkipFeaturesStore,
  useNavigateStore,
  useAppInfoStore,
  useLoadingStore,
  useCheckPasswordStore,
};

const GlobalStore = {
  useModalStore,
  useToastStore,
  useShouldCheckModalStore,
  useNavigateStore,
  useSkipFeaturesStore,
  useAppInfoStore,
  useLoadingStore,
  useCheckPasswordStore,
};

export default GlobalStore;
